/**
 * "Tournament" — the 4th tile inside a tournament game (fix D / R2). It does NOT
 * drop the board the way the result card's "Go to tournament" does: it switches
 * the RAIL to the standings (a Swiss) or the leaderboard (an arena) and leaves
 * the game exactly where it is, which is the whole point of the tabbed rail.
 *
 * `tab` is `tabSpec.ts`'s `resultTabFor` — the one place that rule lives, shared
 * with "Go to tournament" and the idle Stage's "See standings" (G5).
 */
import {useCallback} from 'react';

import {useLiveGame} from '@/Store/liveGameStore';

import {resultTabFor} from '../../tabs/tabSpec';
import {useV2Ui} from '../../../theme/useV2Ui';
import type {V2RailTab} from '../../../theme/useV2Ui';

export type TournamentActionModel = {
  label: string;
  hint: string;
  /** which panel this tournament's "Tournament" tile opens */
  tab: V2RailTab;
  onPress: () => void;
};

export function useTournamentActionModel(): TournamentActionModel {
  const arena = useLiveGame(s => s.tournament.mode === 'arena');
  const setRailTab = useV2Ui(s => s.setRailTab);
  const tab = resultTabFor(arena);

  const onPress = useCallback(() => setRailTab(tab), [setRailTab, tab]);

  return {
    label: 'Tournament',
    hint: arena ? 'Open the arena' : 'Open the standings',
    tab,
    onPress,
  };
}

export default useTournamentActionModel;
